module.exports = {"type":"AppRole","name":"角色权限","defaultName":"未命名角色","placeholder":"请输入角色名称……","icon":"md-contacts","routeName":"role","setRouteName":"roleSet","listRouteName":"roles","listShowFields":[],"dropdownList":[],"template":[]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bri-vtools/src/datas/app/appModuleData/modules/AppRole.json
// module id = 3UvH
// module chunks = 39